import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import {
  QuoteChecklistPageStore,
  QuoteChecklistPageStoreContext,
  useQuoteChecklistPageStore,
} from 'store/pages/quote/quote-checklist/pageStore';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { RouteV2Id } from 'routes/routesConfigV2';
import StepCard from 'components/common/checklist/StepCard';
import { SectionStyled } from './styles';

const PageContent: React.FC = observer(() => {
  const { checklistOptions, getInitialData, flowDelegate, onBackRedirect } = useQuoteChecklistPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={RouteV2Id.QUOTE_CHECKLIST}
      contentWidth="narrow"
      pageHeader={{
        onBackButtonClick: onBackRedirect,
      }}
      isPageLoading={flowDelegate.isInitialDataLoading}
      pageFooter={null}
    >
      <SectionStyled>
        {checklistOptions.map((option) => {
          return (
            <StepCard
              key={`${option.title}`}
              data-test-id={`step-card-${option.title}`}
              title={option.title}
              text={option.text}
              buttonState={option.buttonState}
              completionStatus={option.completionStatus}
              onActionClick={option.onActionClick}
            />
          );
        })}
      </SectionStyled>
    </QuoteFlowLayout>
  );
});

const QuoteChecklistPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(() => new QuoteChecklistPageStore({ groupId, periodId, cartId }), []);
  return (
    <QuoteChecklistPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </QuoteChecklistPageStoreContext.Provider>
  );
};

export default QuoteChecklistPage;
